import React from "react";

import "./App.css";
import Router from "./Router";

function App() {
  return (
    <div className="d-flex bg-body text-body justify-content-center align-items-start">
      <Router />
    </div>
  );
}

export default App;
